import React, { memo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

/**
 * Use memo to prevent re-render using the same data,
 * or else the dots of the line will not be shown.
 * https://github.com/recharts/recharts/issues/804
*/
const SingleLineChart = memo(({
  height,
  data,
  title,
  noTitle,
}) => {
  // Get xAxisKey and yAxisKey
  const xAxisKey = data.length ? Object.keys(data[0])[0] : '';
  const yValueKey = data.length ? Object.keys(data[0])[1] : '';

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart
        data={data}
        margin={{ top: 25, right: 30, left: 0, bottom: 10 }}
      >
        <XAxis dataKey={xAxisKey} interval="preserveStartEnd" />
        <YAxis />
        <CartesianGrid vertical={false} />
        <Tooltip />
        {!noTitle && <Legend verticalAlign="top" />}
        <Line
          name={title}
          dataKey={yValueKey}
          dot={{ stroke: 'black', strokeWidth: 4, fill: 'black' }}
          stroke="black"
          strokeWidth={3}
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}, (prevProps, nextProps) => _.isEqual(prevProps.data, nextProps.data));

SingleLineChart.propTypes = {
  height: PropTypes.number.isRequired,
  /**
   * data is of structure:
   * [
   *  {xkey: xValue1, ykey: yValue1},
   *  {xkey: xValue2, ykey: yValue2},
   *  ...
   * ]
   *  where "xkey" and "ykey" are strings you CAN specify
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    xkey: PropTypes.string,
    ykey: PropTypes.number,
  })).isRequired,
  title: PropTypes.string,
  noTitle: PropTypes.bool,
};

SingleLineChart.defaultProps = {
  title: '',
  noTitle: false,
};

export default SingleLineChart;



// WEBPACK FOOTER //
// ./src/components/shared/SingleLineChart.js